<script context="module" lang="ts">
	export type ItemInfo = { name: string; count: number };

	export type SalesItemsProps = {
		items: ItemInfo[];
		title: string;
	};

</script>

<script lang="ts">
	//UI
	import { Card } from "@hitit/new_ui/src";
	//Utils
	//Types
	//Props
	export let title = "";
	export let items: ItemInfo[] = [];
	//Constants
	//Variables
	//Functions
	//Do

</script>

<Card noPadding>
	<div class="container">
		<p class="title">{title}</p>
		<div class="body">
			{#each items as item}
				<div class="row">
					<span class="name">{item.name}</span>
					<span class="count">{item.count}</span>
				</div>
			{/each}
		</div>
	</div>
</Card>

<style lang="scss">
	.container {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 20px 10px;
		box-sizing: border-box;

		.title {
			color: #46474b;
		}

		.body {
			width: 100%;
			display: flex;
			flex-direction: column;
			.row {
				display: flex;
				justify-content: space-between;
				box-sizing: border-box;
				width: 100%;
				padding: 10px 0px;
				font-weight: 500;
				color: #46474b;
				font-size: 1.25rem;
				gap: 10px;
				.name {
					word-break: break-all;
				}
				&:not(:last-child) {
					border-bottom: 1px solid #e6e7ec;
				}
			}
		}
	}

</style>
